import { FatalErrorCommand } from "slotworks/commands/error/fatal-error-command";
import Components from "slotworks/components/components";
import { AssetConfigSchema } from "slotworks/config/asset-config-schema";
import { ComponentConfigSchema } from "slotworks/config/component-config-schema";
import { GameConfigSchema } from "slotworks/config/game-config-schema";
import { I18NConfigSchema } from "slotworks/config/i18n-config-schema";
import { SoundConfigSchema } from "slotworks/config/sound-config-schema";
import GameLoop from "slotworks/core/game-loop";
import CanvasManager from "slotworks/graphics/canvas/canvas-manager";
import GraphicsManager, { GraphicsManagerError } from "slotworks/graphics/graphics-manager";
import Layers from "slotworks/graphics/layers/layers";
import Translations from "slotworks/i18n/translations";
import Loader from "slotworks/loader/loader";
import GameState from "slotworks/model/game-state";
import AuthRequestPayload from "slotworks/model/gameplay/requests/auth-request-payload";
import SettingsModel from "slotworks/model/settings/settings-model";
import CommsManager from "slotworks/server/comms-manager";
import { SoundEvent } from "slotworks/sound/sound-events";
import SoundManager from "slotworks/sound/sound-manager";
import { StateMachineConfig } from "slotworks/state-machine/parser/config/state-machine-config-schema";
import StateParser from "slotworks/state-machine/parser/state-parser";
import StateMachine from "slotworks/state-machine/state-machine";
import DeviceInfo from "slotworks/utils/device-info";
import SpineManager from "./graphics/spine/spine-manager";
import { SpineConfigSchema } from "./config/spine-config-schema";
import { ParticleConfigSchema } from "slotworks/config/particle-config-schema";

export default class AppWorks {

    public static go(gameConfig: GameConfigSchema,
                     stateConfig: StateMachineConfig,
                     assetConfig: AssetConfigSchema,
                     componentConfig: ComponentConfigSchema,
                     soundConfig: SoundConfigSchema,
                     i18nConfig: I18NConfigSchema,
                     spineConfig: SpineConfigSchema,
                     particleConfig: ParticleConfigSchema,
                     ready: Function) {

        window.onerror = () => {
            FatalErrorCommand(Translations.get("@err_server_generic"));
            window.onerror = null;
        };

        DeviceInfo.selectLayout(gameConfig.layouts);

        SoundManager.registerSounds(soundConfig);

        StateMachine.onStateEnter.add((state: string) => SoundManager.event(SoundEvent.enter_state_STATE, state));
        StateMachine.onStateExit.add((state: string) => SoundManager.event(SoundEvent.exit_state_STATE, state));

        Layers.onEnterScene.add((layer: string, scene: string) => SoundManager.event(SoundEvent.enter_scene_LAYER_SCENE, layer, scene));
        Layers.onExitScene.add((layer: string, scene: string) => SoundManager.event(SoundEvent.exit_scene_LAYER_SCENE, layer, scene));

        CanvasManager.init(assetConfig);
        GraphicsManager.init(assetConfig);

        Components.config = componentConfig;
        Components.particles = particleConfig;
        Components.preinit();

        SpineManager.setConfig(spineConfig);

        GameLoop.init().then(() => {

            Loader.loadI18n(SettingsModel.language || "en").then((json) => {

                Translations.setLanguage(SettingsModel.language || "en");
                Translations.setConfig(i18nConfig);
                Translations.load(json);
                Translations.updateDOMTexts();

                if (DeviceInfo.isIE11()) {
                    document.body.style.display = "";
                    FatalErrorCommand(Translations.get("ie1.1er"));
                    return;
                }

                GameState.newGame();

                CommsManager.request(new AuthRequestPayload()).then(() => {
                    Loader.load(assetConfig).then(() => {

                        CanvasManager.gameLoaded();

                        SettingsModel.loadBet();

                        const defaultState = StateParser.parse(stateConfig, StateMachine);

                        ready();
                        
                        try {
                            StateMachine.setCurrentState(defaultState);
                        } catch(e) {
                            // catch Graphic Manager Error and display a meaningful message prompt
                            if((e as GraphicsManagerError).graphicError === true) {
                                console.error(e); // log the error to console
                            } else {
                                throw e;
                            }
                        }
                    });
                });
            });
        });
    }

    private constructor() { }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/appworks.ts